
import HttpClient from '../HttpService';

function toggleIsActive(userId, companyid) {
    return HttpClient.put(`/workers/status/${userId}`, { company: companyid });
}

function list(companyId, showAll) {
    if (showAll) {
        return HttpClient.get(`/workers/${companyId}?show_inactives=all`);
    } else {
        return HttpClient.get(`/workers/${companyId}`);
    }
}

function create(data) {
    return HttpClient.post(`/workers/`, data);
}

function update(data) {
    return HttpClient.put(`/workers/${data.id}`, data);
}

function linkBoss(bossId, workersIds, companyId) {
    return HttpClient.put(`/workers/linkboss`, { boss_id: bossId, workers_ids: workersIds, company: companyId });
}

function getWorkersWithSubordinates(companyId) {
    return HttpClient.get(`/workers/company/${companyId}/managers`);
}

function updatePDIForm(workerId, pdiForm) {
    return HttpClient.put(`/workers/${workerId}/pdi-form`, { pdiformid: pdiForm });
}

function getBonusRules(workerId, companyId, competenceMonth, competenceYear) {
    return HttpClient.get(`/workers/${workerId}/bonus-rules`, {
        params: {
            company_id: companyId,
            competence_month: competenceMonth,
            competence_year: competenceYear
        }
    });
}

function saveBonusRules(workerId, payload) {
    return HttpClient.put(`/workers/${workerId}/bonus-rules`, payload);
}

export default {
	updatePDIForm,
	getWorkersWithSubordinates,
    toggleIsActive,
    list,
    create,
    update,
    linkBoss,
    getBonusRules,
    saveBonusRules
}
